import login from "./index.vue";

(login as any).install = function (Vue: any) {
  Vue.component(login.name, login);
};

export default login;
